var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-full-details.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-full-details.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
output += "\n\n<div class=\"c-product-full-details dom-product-full-details\">\n\n    ";
var t_6;
t_6 = (lineno = 4, colno = 36, runtime.callWrap(t_4, "quickshopUrl", context, [env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"url"))]));
frame.set("titleLinkURL", t_6, true);
if(frame.topLevel) {
context.setVariable("titleLinkURL", t_6);
}
if(frame.topLevel) {
context.addExport("titleLinkURL", t_6);
}
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideFullDetails")) {
output += "<a ";
output += runtime.suppressValue((lineno = 7, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",(runtime.contextOrFrameLookup(context, frame, "productTypeOverride")?runtime.contextOrFrameLookup(context, frame, "productTypeOverride"):(lineno = 7, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"]))),"related pdp"])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "titleLinkURL"), env.opts.autoescape);
output += "\" class=\"c-product-full-details__a\" data-qa-full-details>\n            ";
output += runtime.suppressValue((lineno = 8, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_full-details"])), env.opts.autoescape);
output += "\n        </a>";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-full-details.j2"] , dependencies)